// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.border-radius[data-v-014dd788] {\r\n  border-radius: 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
